/* kult-search.js — Suche: Vorschläge beim Tippen (Shopify Predictive Search), Synonyme aus den
   Theme-Settings, Sortierung der Suchseite und Rückschreiben des Originalbegriffs (Parameter kq).
   Markup: snippets/kult-search-form.liquid, Konfiguration: snippets/kult-search-config.liquid. 03.10.2026 */
(function () {
  'use strict';
  if (customElements.get('kult-search')) return;

  var cfg = {};
  try {
    var cfgEl = document.getElementById('kult-search-config');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent || '{}') || {};
  } catch (e) { cfg = {}; }
  var SEARCH_URL = cfg.searchUrl || '/search';
  var SUGGEST_URL = (cfg.suggestUrl || '/search/suggest') + '.json';

  function norm(s) {
    return String(s || '').trim().toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/\s+/g, ' ');
  }
  var SYN = {};
  String(cfg.synonyms || '').split(/\r?\n/).forEach(function (line) {
    var i = line.indexOf(':');
    if (i < 0) return;
    var keys = line.slice(0, i).split(',').map(norm).filter(Boolean);
    var syns = line.slice(i + 1).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!keys.length || !syns.length) return;
    keys.forEach(function (k) { SYN[k] = (SYN[k] || []).concat(syns); });
  });

  /* Hängt Synonyme als weitere Suchwörter an; Shopify verknüpft Wörter mit ODER und gewichtet die Treffer. */
  function expand(q) {
    var t = String(q || '').trim();
    if (!t) return t;
    var extra = [];
    var add = function (list) {
      (list || []).forEach(function (s) { if (norm(s) !== norm(t) && extra.indexOf(s) < 0) extra.push(s); });
    };
    add(SYN[norm(t)]);
    t.split(/\s+/).forEach(function (w) { add(SYN[norm(w)]); });
    return extra.length ? t + ' ' + extra.join(' ') : t;
  }
  function searchHref(q) {
    var ex = expand(q);
    return SEARCH_URL + '?q=' + encodeURIComponent(ex) + (ex !== q ? '&kq=' + encodeURIComponent(q) : '') + '&options%5Bprefix%5D=last';
  }

  /* Tee, Confiserie und Manufaktur-Artikel gibt es nur im Konfigurator: Privatkunden → Geschenke, Firmenkunden → Firmenpräsente */
  function isB2b() {
    try { return sessionStorage.getItem('kult:bereich') === 'b2b' || localStorage.getItem('kult:b2b') === '1'; } catch (e) { return false; }
  }
  function giftUrl(forceB2b) {
    return (forceB2b || isB2b()) ? '/pages/firmenpraesente#konfigurator' : '/pages/geschenke#konfigurator';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }
  var ARROW = '<svg width="16" height="12" viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h14M10 1l5 5-5 5"/></svg>';

  class KultSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.panel = this.querySelector('[data-search-panel]');
      this.clearBtn = this.querySelector('[data-search-clear]');
      if (!this.form || !this.input || !this.panel) return;
      this.timer = null; this.ctrl = null; this.active = -1; this.options = []; this.lastQuery = '';
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.input.addEventListener('focus', () => {
        if (this.options.length && this.input.value.trim() === this.lastQuery) this.open();
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.panel.addEventListener('mousedown', (e) => e.preventDefault());
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => {
          this.input.value = ''; this.options = []; this.toggleClear(); this.close(); this.input.focus();
        });
      }
      this.toggleClear();
    }
    toggleClear() { if (this.clearBtn) this.clearBtn.hidden = !this.input.value; }
    onInput() {
      this.toggleClear();
      clearTimeout(this.timer);
      var q = this.input.value.trim();
      if (q.length < 2) { this.close(); this.options = []; return; }
      this.timer = setTimeout(() => this.load(q), 180);
    }
    load(q) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = new AbortController();
      var url = SUGGEST_URL + '?q=' + encodeURIComponent(expand(q)) +
        '&resources[type]=product,page,article,collection&resources[limit]=5&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      fetch(url, { signal: this.ctrl.signal, headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => { if (j && j.resources) this.render(q, j.resources.results || {}); })
        .catch(() => {});
    }
    render(q, res) {
      var b2b = isB2b();
      /* Pralinés mit Alkohol nur für Firmenkunden (D4, 11.10.2026); greift zusätzlich zu seo.hidden im Admin */
      var products = (res.products || []).filter(function (p) {
        var t = p.tags || [];
        var praline = (p.type || p.product_type) === 'Confiserie' || t.indexOf('confiserie') > -1;
        return b2b || !(t.indexOf('alkohol_mit') > -1 && praline);
      });
      var pages = (res.pages || []).concat(res.articles || []).concat(res.collections || []);
      var id = this.panel.id;
      var idx = 0;
      var html = '';
      if (products.length) {
        html += '<div class="kult-search__group" role="group" aria-label="Produkte"><div class="kult-search__group-title" aria-hidden="true">Produkte</div>';
        products.forEach((p) => {
          var giftOnly = (p.tags || []).some(function (t) { return t === 'tee' || t === 'confiserie' || t === 'manufaktur'; });
          if (giftOnly) p = Object.assign({}, p, { url: giftUrl((p.tags || []).indexOf('manufaktur') > -1), product_type: 'In der Kult-Box' });
          var meta = [p.product_type, money(p.price)].filter(Boolean).join(' · ');
          var img = p.featured_image && p.featured_image.url
            ? '<img class="kult-search__thumb" src="' + esc(thumb(p.featured_image.url)) + '" alt="" loading="lazy" width="56" height="56">'
            : '<span class="kult-search__thumb" aria-hidden="true"></span>';
          html += '<a class="kult-search__item" role="option" id="' + id + '-o' + (idx++) + '" href="' + esc(p.url) + '" aria-selected="false">' + img +
            '<span class="kult-search__item-body"><span class="kult-search__item-title">' + esc(p.title) + '</span>' +
            (meta ? '<span class="kult-search__item-meta">' + esc(meta) + '</span>' : '') + '</span></a>';
        });
        html += '</div>';
      }
      if (pages.length) {
        html += '<div class="kult-search__group" role="group" aria-label="Seiten und Wissen"><div class="kult-search__group-title" aria-hidden="true">Seiten &amp; Wissen</div>';
        pages.forEach((p) => {
          html += '<a class="kult-search__item kult-search__item--page" role="option" id="' + id + '-o' + (idx++) + '" href="' + esc(p.url) + '" aria-selected="false"><span class="kult-search__item-title">' + esc(p.title) + '</span></a>';
        });
        html += '</div>';
      }
      if (!html) html = '<p class="kult-search__none">Keine Vorschläge für „' + esc(q) + '“. Mit Enter suchst du im ganzen Shop.</p>';
      html += '<a class="kult-search__all" role="option" id="' + id + '-o' + (idx++) + '" href="' + esc(searchHref(q)) + '" aria-selected="false"><span>Alle Ergebnisse für „' + esc(q) + '“</span>' + ARROW + '</a>';
      this.panel.innerHTML = html;
      this.options = Array.prototype.slice.call(this.panel.querySelectorAll('[role="option"]'));
      this.active = -1;
      this.lastQuery = q;
      this.open();
    }
    open() { this.panel.hidden = false; this.input.setAttribute('aria-expanded', 'true'); this.classList.add('is-open'); }
    close() {
      this.panel.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.classList.remove('is-open');
      this.active = -1;
      this.options.forEach((o) => { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
    }
    setActive(i) {
      if (!this.options.length) return;
      if (i < 0) i = this.options.length - 1;
      if (i >= this.options.length) i = 0;
      this.options.forEach((o, k) => {
        var on = k === i;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.active = i;
      this.input.setAttribute('aria-activedescendant', this.options[i].id);
      this.options[i].scrollIntoView({ block: 'nearest' });
    }
    onKey(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (this.panel.hidden) {
        if (e.key === 'ArrowDown' && this.options.length) { e.preventDefault(); this.open(); this.setActive(0); }
        return;
      }
      if (e.key === 'ArrowDown') { e.preventDefault(); this.setActive(this.active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.setActive(this.active - 1); }
      else if (e.key === 'Enter' && this.active >= 0) { e.preventDefault(); window.location.href = this.options[this.active].href; }
    }
    onSubmit(e) {
      var q = this.input.value.trim();
      if (!q) { e.preventDefault(); this.input.focus(); return; }
      var ex = expand(q);
      if (ex !== q) {
        this.input.value = ex;
        var kq = this.form.querySelector('input[name="kq"]');
        if (!kq) { kq = document.createElement('input'); kq.type = 'hidden'; kq.name = 'kq'; this.form.appendChild(kq); }
        kq.value = q;
      }
      this.close();
    }
  }
  customElements.define('kult-search', KultSearch);

  /* Suchseite: Originalbegriff zurückschreiben, Sortierung per sort_by */
  function initPage() {
    var params = new URLSearchParams(window.location.search);
    var kq = params.get('kq');
    if (kq) {
      document.querySelectorAll('[data-search-term]').forEach(function (el) { el.textContent = kq; });
      document.querySelectorAll('kult-search input[type="search"]').forEach(function (el) { el.value = kq; });
      var q = params.get('q');
      if (q && document.title.indexOf(q) >= 0) document.title = document.title.replace(q, kq);
    }
    if (isB2b()) {
      document.querySelectorAll('[data-gift-only] a.kult-plp-card__submit').forEach(function (a) { a.setAttribute('href', giftUrl(true)); });
    }
    var sort = document.querySelector('[data-search-sort]');
    if (sort) {
      var cur = params.get('sort_by') || 'relevance';
      if (sort.querySelector('option[value="' + cur + '"]')) sort.value = cur;
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        if (sort.value === 'relevance') u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
})();
